import React from 'react';
import styles from '../../styles/components/Welcome.module.css';
import logoImage from '../../assets/nana_cece_logo_main.png';
import backgroundImage from '../../assets/nana_cece_banner.png';
import KitSubscribe from './KitSubscribe';

const Welcome = () => {
  return (
    <section 
      className={`${styles.welcomeSection} welcomeSection`}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className={styles.content}>
        <img
          src={logoImage}
          alt="Nana + Cece"
          className={styles.mainLogo}
        />
        <h1 className={styles.mainTitle}>Memories in the Making</h1>
        <h2 className={styles.subtitle}>Activities, Projects, and Tips for the busy family that wants to make every moment count.</h2>
        <div className={styles.contentWrapper}>
          <h3 className={styles.subscribetitle}>Subscribe for regular updates straight to your inbox.</h3>
          <KitSubscribe />
        </div>
        {/* <div className={styles.categories}>
          <h3>Categories</h3>
          <ul>
            <li>Kids</li>
            <li>Parenting</li>
            <li>Events</li>
            <li>Travel</li>
          </ul>
        </div> */}
      </div>
    </section>
  );
};

export default Welcome;